import { slice_admin_users } from './_admin/admin_users/slice_admin_users';
import { slice_app_info } from './app_info/slice_app_info';
import { slice_collections } from './collection/slice_collections';
import { slice_ml_asset } from './diffusion_models_ud/slice_ml_asset';
import { slice_generation } from './generation/slice_generation';
import { slice_generation_price } from './generation_price/slice_generation_price';
import { slice_grid2d } from './grid2d/slice_grid2d';
import { slice_images } from './images/slice_images';
import { slice_network } from './network/slice_network';
import { slice_search } from './search/slice_search';
import { slice_ui } from './ui/slice_ui';
import { slice_user } from './user/slice_user';
import { slice_words } from './words/slice_words';
import { slice_workspace_billing } from './workspace/billing/slice_workspace_billing';
import { slice_workspace } from './workspace/slice_workspace';

export const slices = {
  slice_app_info,
  slice_collections,
  slice_ml_asset,
  slice_generation,
  slice_generation_price,
  slice_grid2d,
  slice_network,
  slice_images,
  slice_search,
  slice_ui,
  slice_user,
  slice_words,
  slice_workspace,
  slice_workspace_billing,

  slice_admin_users,
};

export const slice_reducers = {
  slice_app_info: slice_app_info.reducer,
  slice_collections: slice_collections.reducer,
  slice_generation: slice_generation.reducer,
  slice_generation_price: slice_generation_price.reducer,
  slice_grid2d: slice_grid2d.reducer,
  slice_network: slice_network.reducer,
  slice_images: slice_images.reducer,
  slice_ml_asset: slice_ml_asset.reducer,
  slice_search: slice_search.reducer,
  slice_user: slice_user.reducer,
  slice_ui: slice_ui.reducer,
  slice_words: slice_words.reducer,
  slice_workspace: slice_workspace.reducer,
  slice_workspace_billing: slice_workspace_billing.reducer,
  slice_admin_users: slice_admin_users.reducer,
};

export let slice_actions = {};

for (let slice_name of Object.keys(slices)) {
  for (let action_name of Object.keys((slices as any)[slice_name].actions)) {
    (slice_actions as any)[`${slice_name}/${action_name}`] = (slices as any)[slice_name].actions[action_name];
  }
}
